<template>
  <b-modal size="lg" v-model="visible" :hide-header="true" :hide-footer="true">
    <div class="certificate-container text-center">
      <img class="certificate-img" src="../assets/images/ketdoi.png"/>
      <div class="toolbar">
        <button @click="visible = false" class="toolbar-button">
          <i class="fa fa-times-circle"></i>
        </button>
        <button class="toolbar-button-go-next toolbar-button" @click="see">
          Xem và chia sẻ
          <i class="fa fa-arrow-circle-right"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "PopUpKetDoi",
  data() {
    return {
      visible: false,
      url: 'https://www.facebook.com/thaythuocdonghanh/photos/a.107224621655304/145763124468120/'
    }
  },
  mounted() {
    let show = false;
    let lastSeenPopUpTime = localStorage.getItem('lastSeenPopUpTime');
    if (!lastSeenPopUpTime || lastSeenPopUpTime + 8 * 60 * 60 * 1000 < Date.now()) {
      show = true;
    }
    if (['bac-sy', 'bac-sy-pho-nhom', 'bac-sy-truong-nhom', 'nvyt', 'owner'].includes(this.$store.state.user.role) && show) {
      this.show();
    }
  },
  methods: {
    show() {
      this.visible = true;
      localStorage.setItem('lastSeenPopUpTime', Date.now());
    },
    see() {
      this.visible = false;
      window.open(this.url, '_blank');
    }
  }
}
</script>

<style scoped>
.certificate-container {
  position: relative;
}
.certificate-img {
  width: 75%;
}
.toolbar {
  position: absolute;
  bottom: 0;
  width: 100%;
  transform: translate(0, 74px);
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 50px;
}

.toolbar:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.toolbar-button-go-next {
  justify-content: flex-end;
  min-width: 100px;
}

.toolbar-button {
  align-items: center;
  background-color: transparent;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  font-weight: bold;
  opacity: 75%;
  outline: none;
  overflow: hidden;
}

.toolbar-button:hover {
  opacity: 100%;
}

.toolbar-button i.fa {
  font-size: 30px;
  margin: 5px;
}
</style>